import { getCompatConfig } from '../compat.js';

const setRedirectUrlAfterAuth = (url) => {
  getCompatConfig().AUTH.setRedirectUrlAfterAuth(url);
};
const getRedirectUrlAfterAuth = () => {
  return getCompatConfig().AUTH.getRedirectUrlAfterAuth();
};

export { getRedirectUrlAfterAuth, setRedirectUrlAfterAuth };
//# sourceMappingURL=auth.js.map
